import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from './utils/util'
import * as filters from './filters'
import Service from './common/axios-config'
import apis from "./common/api-config";
import './assets/css/base.css'
import 'lib-flexible/flexible'
import Vant,{Lazyload} from 'vant';
import 'vant/lib/index.css';
Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(Lazyload);
// 全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 全局工具
window.$store = store;
window.utils = Vue.prototype.utils = utils
window.$http = Vue.prototype.$http = Service
window.$apis = Vue.prototype.$apis = apis
if (window.isWanka) {
  window.getTokenFromApp()
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
